export const environment = {
  apiRoot: 'https://dev.api.beoexpo.com/',

  accessTokenName: 'beoexpo_prod_access_token',
};
